import React from "react"

export default ({ url, title, isShort = true }) => {
    let aClassName = "btn"
    if (!isShort) {
        aClassName += " btn-primary"
    }
    let iconClassName = ""
    if (isShort) {
        iconClassName = "icon-download-pdf"
    } else {
        iconClassName = "icon icon-download"
    }
    return (
        <a
            className={aClassName}
            href={url}
            download={title}
            target="_blank"
            rel="noopener noreferrer"
        >
            <span className={iconClassName} />
            {!isShort && <span>Download</span>}
        </a>
    )
}
